import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { BINARY_DECOMPOSITION } from '../../../../../shared/featureFlags/flagNames';
import { FilterKeys } from '../../../../../shared/projectsV2';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardCheckboxes from '../../../generic/Filter/FilterCardCheckboxes';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { ProjectsFilter, ProjectType as ProjType } from '../../../../../shared/projectsV2';
import type { SelectOption } from '../../../../types';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'provided', label: 'CLI upload' },
  { value: 'container', label: 'Container' },
  { value: 'archive', label: 'Archive upload' },
  { value: 'autobuild', label: 'Quick import' },
  { value: 'sbom', label: 'SBOM import' },
  { value: 'binary', label: 'Binary Decomposition' },
];

const ProjectType: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedTypes = newSelected.map(({ value }) => value as ProjType);
    setFilter({ ...filter, [FilterKeys.Type]: selectedTypes });
  };

  // map current filter.type to SelectOption format
  const selectedCheckboxes = (filter.type ?? []).map((type: string) => ({
    label: FILTER_OPTIONS.find(option => option.value === type)?.label || type,
    value: type,
  }));

  // Binary Decomposition project attribute should only be displayed when feature is enabled.
  const isBinaryDecompositionEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);
  const options = FILTER_OPTIONS.filter(
    entry => (isBinaryDecompositionEnabled || entry.value !== 'binary'));

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Project attributes"
        options={options}
        values={selectedCheckboxes}
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default ProjectType;
